import { render, staticRenderFns } from "./RCcomplainList.vue?vue&type=template&id=76f5e672&scoped=true&"
import script from "./RCcomplainList.vue?vue&type=script&lang=js&"
export * from "./RCcomplainList.vue?vue&type=script&lang=js&"
import style0 from "./RCcomplainList.vue?vue&type=style&index=0&id=76f5e672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5e672",
  null
  
)

export default component.exports